import { render, staticRenderFns } from "./SlicesPanel.vue?vue&type=template&id=2edd8588&scoped=true&"
import script from "./SlicesPanel.vue?vue&type=script&lang=js&"
export * from "./SlicesPanel.vue?vue&type=script&lang=js&"
import style0 from "./SlicesPanel.vue?vue&type=style&index=0&id=2edd8588&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edd8588",
  null
  
)

export default component.exports